import Http from 'axios'
import {
    API_URL,
    VERSION, VERSIONED_API_URL
} from '../../config/config'

function initialState() {
    return {
        all: [],
        query: '',
        serverPagination: {
            page: 1,
            rowsNumber: 0,
            sortBy: null,
            descending: false,
            itemsPerPage: 25
        },
        totalNumber: 0,
        filters: {},
        loading: false,
        user: {},
        user_groups: [],
        filtered_users: []
    }
}

const getters = {
    all: state => state.all,
    loading: state => state.loading,
    serverPagination: state => state.serverPagination,
    filters: state => state.filters,
    query: state => state.query,
    user: state => state.user,
    totalNumber: state => state.totalNumber,

};

const actions = {
    getAll({commit, state}) {
        commit('setLoading', true);
        Http.get(API_URL + VERSION + '/users', {
            params: state.filters
        }).then((response) => {
            commit('setAll', response.data.data)
        });
    },
    async getDataFromFilters({commit, state}, filters) {
        try {
            const {data} = await Http.get(`${VERSIONED_API_URL}/users`, {
                params: filters
            });
            commit('setFilteredUsers', data.data);
        } catch (e) {
            throw e;
        }
    },
    create({
               commit,
               state
           }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/users/save', state.user)
                .then(response => {
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    delete({
               commit,
               state
           }, items) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/users/delete', {
                'delete_rows': items
            })
                .then(response => {
                    commit('setLoading', false)
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false)
                    reject(error)
                })
        });
    },
    async getUserByGroup({commit}, group) {
        try {
            const {data} = await Http.get(`${VERSIONED_API_URL}/users`, {
                params: {
                    group
                }
            });
            commit('setUserGroup', data);
        } catch (e) {
            throw  e;
        }

    },
    resetState({
                   commit
               }) {
        commit('resetState')
    }
}

const mutations = {
    setAll(state, items) {
        items = items.map((item, index) => {
            item.s_no = (state.serverPagination.page - 1) * state.serverPagination.itemsPerPage + (index + 1);
            return item;
        });
        state.all = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setUser(state, user) {
        state.user = user
    },
    setServerPagination(state, item) {
        state.serverPagination = item
    },
    setTotalNumber(state, item) {
        state.totalNumber = item
    },
    setQuery(state, query) {
        state.query = query
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setFilters(state, item) {
        state.filters = item
    },
    setUserGroup(state, item) {
        state.user_groups = item.data;
    },
    setFilteredUsers(state, item) {
        state.filtered_users = item;
    }
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
